export const navigation = {
    about: {
        path: 'about',
        text: 'About'
    },
    members: {
        path: 'members',
        text: 'Members'
    },
    services: {
        path: 'services',
        text: 'Services'
    },
    reviews: {
        path: 'reviews',
        text: 'Reviews'
    },
    Sponsors: {
        path: 'sponsors',
        text: 'Sponsors'
    },

    contacts: {
        path: 'contacts',
        text: 'Contacts'
    },
}